
const data = [
    {
        title:"Level 1 Ski Instructor",
        organization: "CADS",
        description:"Volunteer ski instructor for disabled skiiers",
        timeframe:"Dec 2009 - Current",
        link:"https://www.youtube.com/embed/W0FKeQPf6mQ"
    },
    {
        title:"Goalie in Training",
        organization: "TNHC",
        description:"A late timer getting into the hockey game (goalie in white)",
        timeframe:"Jul 2019 - Current",
        link:"https://www.youtube.com/embed/13kMsiRdbrc?t=215"
    }
]

export default data;